var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('SelectComponent',{staticClass:"post-publishing",attrs:{"value":_vm.relationRef,"items":_vm.items,"label":_vm.$t('publishPostSelectPost')},on:{"input":_vm.setRelation}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }